import React, { Component } from 'react';
import { Select, Slider, Button } from 'antd';
import request from "@/method/request";

import "./index.scss";
import getJson from '../../../method';

const { Option } = Select;

class index extends Component {
    state = {
        data: [],
        value: "",
        width: localStorage.getItem('width') || 1200,
        type: '',
        list: []
    }

    componentDidMount() {

        this.getData();
    }

    getData = async () => {
        try {
            const res = await request("/consulting/lst");
            const type = res.data[0] ? res.data[0].type : "";
            const list = [...new Set((res.data || []).map(x => x.type))];
            this.setState({ type, list, data: res.data || [], value: getJson([0, 'name'], res.data || [], '') });
        } catch (error) {
            console.log(error);
        }
    }


    render() {
        const { data, value, width, type, list } = this.state;
        const item = data.find(x => x.name == value) || {};
        return (
            <div className="consulting">
                <div className="title">Consulting Reports 第三方行业资讯报告摘要</div>
                <div className="type">
                    {
                        list.map(x => {
                            return <Button onClick={() => {
                                this.setState({ type: x, value: (data.find(v => v.type == x) || {}).name || "" });
                            }} type={x == type ? 'primary' : ''}>{x}</Button>
                        })
                    }
                </div>
                <div className="select">
                    <Select
                        value={value}
                        showSearch
                        onChange={value => this.setState({ value })}
                    >
                        {
                            data.filter(x => x.type == type).map(x => <Option key={x.name}>{x.name}</Option>)
                        }
                    </Select>
                </div>

                <div className="content">
                    <div className="item-title">{item.name || ""}</div>
                    <div className="desc">{item.source ? item.source : ''}</div>
                    <Slider value={width} min={800} max={1800} onChange={v => {
                        localStorage.setItem('width', v)
                        this.setState({ width: v })
                    }} />
                    {
                        JSON.parse(item.img || "[]").map(x => {
                            return <img key={x.uid} style={{ width }} src={x.url} alt="" className="img-item" />
                        })
                    }
                </div>
            </div >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/consulting/index.js